import { FC, useCallback } from "react";
import { IconButton, Tooltip } from "@mui/material";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import { useAppSelector } from "../../../../../../store/hooks";
import { ResourceType } from "../../../../../../services/cloudchipr.api";
import { kubernetesLiveUsageMgmtResourceTypeCsvDataFileNameSelector } from "../../../../../../store/kubernetes-live-usage-mgmt/selectors/resource-type-data/kubernetesLiveUsageMgmtResourceTypeCsvDataFileNameSelector";
import type { GridApi } from "ag-grid-community";

interface K8SLiveUsageResourceGridCsvExportProps {
  resourceType: ResourceType;
  gridApi: GridApi | null;
}

export const K8SLiveUsageResourceGridCsvExport: FC<
  K8SLiveUsageResourceGridCsvExportProps
> = ({ resourceType, gridApi }) => {
  const fileName = useAppSelector((state) =>
    kubernetesLiveUsageMgmtResourceTypeCsvDataFileNameSelector(
      state,
      resourceType,
    ),
  );

  const exportDataAsCsv = useCallback(() => {
    gridApi?.exportDataAsCsv({ fileName: `${fileName}.csv` });
  }, [gridApi, fileName]);

  return (
    <Tooltip title={`${fileName}_csv`} arrow placement="top">
      <IconButton size="medium" onClick={exportDataAsCsv}>
        <DownloadOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};
